import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Nav from './Components/Nav';
import Header from './Components/Header';
import Footer from './Components/Footer';


function App() {
  return (
    <div className="App">
     <BrowserRouter>
     <Nav/>
   
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/contact' element={<Contact/>}/>
      </Routes>
   <a href="https://wa.me/79917370144" className="whatsapp-btn" target="_blank" rel="noopener noreferrer">
           <i className="bi bi-whatsapp"></i>
           </a>
      <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
